export const CONSENT_VERSION = 'v0.3-borrador-legal-pending';
export const LEGAL_PENDING = true;
export const INTRO_V02 = 'Esta autoevaluación es parte del Framework de Adopción de IA del Espacio de Innovación con IA de CESSI. Le tomará unos 20 minutos. Elija en cada pregunta la opción que mejor describe la realidad actual de su organización, no la aspiración; ante la duda entre dos opciones, elija la más baja. No hay respuestas correctas: es una foto para trabajar. Recibirá su perfil de madurez individual con tres capacidades recomendadas para el próximo trimestre. Los resultados agregados se publican solo de forma anónima. Complete una sola respuesta por organización (si hay más de una, vale la última).';
export const BLOQUE0_PAGINA2 = [
    {
        id: 'p0_1',
        codigo: 'p0_1',
        texto: '0.1 · ¿Cuál es el modelo de negocio principal?',
        opciones: [
            { value: 'solo_productos', label: 'Solo productos propios' },
            { value: 'mayormente_productos', label: 'Mayormente productos, con servicios' },
            { value: 'mezcla', label: 'Mezcla equilibrada de productos y servicios' },
            { value: 'mayormente_servicios', label: 'Mayormente servicios, con productos' },
            { value: 'solo_servicios', label: 'Solo servicios' },
        ],
    },
    {
        id: 'p0_2',
        codigo: 'p0_2',
        texto: '0.2 · ¿Qué perfil describe mejor a la organización?',
        opciones: [
            { value: 'software_factory', label: 'Software factory / desarrollo a medida' },
            { value: 'consultora', label: 'Consultora o integradora' },
            { value: 'producto_saas', label: 'Empresa de producto / SaaS' },
            { value: 'startup', label: 'Startup (producto en etapa de escala)' },
            { value: 'staffing', label: 'Servicios profesionales IT (staffing/talento)' },
            { value: 'otra', label: 'Otra' },
        ],
    },
    {
        id: 'p0_3',
        codigo: 'p0_3',
        texto: '0.3 · ¿Cuántas personas trabajan en la organización?',
        opciones: [
            { value: '1-10', label: '1-10' },
            { value: '11-50', label: '11-50' },
            { value: '51-200', label: '51-200' },
            { value: '201-500', label: '201-500' },
            { value: '501-1000', label: '501-1000' },
            { value: '1000+', label: 'Más de 1000' },
        ],
    },
    {
        id: 'p0_4',
        codigo: 'p0_4',
        texto: '0.4 · ¿En qué sector opera la mayor parte de sus clientes? (Elija hasta 5 opciones)',
        opciones: [
            { value: 'finanzas_seguros', label: 'Servicios financieros y seguros —incluye banca y fintech—' },
            { value: 'retail_consumo', label: 'Comercio, retail y consumo masivo' },
            { value: 'industria_manufactura', label: 'Industria y manufactura' },
            { value: 'tecnologia_telco_medios', label: 'Tecnología, telecomunicaciones y medios' },
            { value: 'salud_vida', label: 'Salud y ciencias de la vida' },
            { value: 'agro_alimentos', label: 'Agroindustria y alimentos' },
            { value: 'energia_mineria_utilities', label: 'Energía, minería y servicios públicos' },
            { value: 'transporte_logistica_automotriz', label: 'Transporte, logística y automotriz' },
            { value: 'gobierno_publico', label: 'Gobierno y sector público' },
            { value: 'educacion', label: 'Educación' },
            { value: 'servicios_profesionales', label: 'Servicios profesionales' },
            { value: 'construccion_inmobiliario', label: 'Construcción y mercado inmobiliario' },
            { value: 'turismo_hospitalidad', label: 'Turismo y hospitalidad' },
            { value: 'multiples_sin_predominio', label: 'Múltiples sectores, sin uno predominante' },
            { value: 'otro', label: 'Otro' },
        ],
    },
];
export const BLOQUE0_PAGINA3 = [
    {
        id: 'p0_5',
        codigo: 'p0_5',
        texto: '0.5 · ¿Dónde opera la organización?',
        opciones: [
            { value: 'solo_ar', label: 'Solo en Argentina' },
            { value: 'ar_1_3', label: 'Argentina + 1-3 países' },
            { value: 'ar_4_10', label: 'Argentina + 4-10 países' },
            { value: 'ar_10_plus', label: 'Argentina + más de 10 países' },
            { value: 'fuera_ar', label: 'Operación principal fuera de Argentina' },
        ],
    },
    {
        id: 'p0_6',
        codigo: 'p0_6',
        texto: '0.6 · ¿Qué porcentaje de la facturación proviene del exterior?',
        opciones: [
            { value: '0', label: '0%' },
            { value: 'lt25', label: 'Menos del 25%' },
            { value: '25_50', label: 'Entre 25% y 50%' },
            { value: 'gt50', label: 'Más del 50%' },
        ],
    },
    {
        id: 'p0_7',
        codigo: 'p0_7',
        texto: '0.7 · ¿Cuál es su rol?',
        opciones: [
            { value: 'ceo', label: 'CEO/fundador' },
            { value: 'clevel', label: 'C-level de negocio' },
            { value: 'cto', label: 'CTO/responsable de tecnología' },
            { value: 'otro', label: 'Otro rol estratégico' },
        ],
    },
    {
        id: 'p0_8',
        codigo: 'p0_8',
        texto: '0.8 · ¿Cómo usa hoy la organización la IA?',
        opciones: [
            { value: 'nivel_0', label: 'Nivel 0 - No usamos' },
            { value: 'nivel_1', label: 'Nivel 1 - Experimentación (ChatGPT, Claude, Copilot)' },
            { value: 'nivel_2', label: 'Nivel 2 - Productividad del rol (individual)' },
            { value: 'nivel_3', label: 'Nivel 3 - Flujos asistidos personales' },
            { value: 'nivel_4', label: 'Nivel 4 - Proceso productivo Human + AI' },
            { value: 'nivel_5', label: 'Nivel 5 - AI Operating Model' },
        ],
    },
    {
        id: 'p0_9',
        codigo: 'p0_9',
        texto: '0.9 · ¿Cuántos años tiene la organización?',
        opciones: [
            { value: 'menos_5', label: 'Menos de 5 años' },
            { value: '5_15', label: 'Entre 5 y 15 años' },
            { value: 'mas_15', label: 'Más de 15 años' },
        ],
    },
    {
        id: 'p0_10',
        codigo: 'p0_10',
        texto: '0.10 · ¿En qué provincia está la sede principal?',
        opciones: [
            { value: 'Buenos Aires', label: 'Buenos Aires' },
            { value: 'CABA', label: 'Ciudad Autónoma de Buenos Aires' },
            { value: 'Córdoba', label: 'Córdoba' },
            { value: 'Santa Fe', label: 'Santa Fe' },
            { value: 'Mendoza', label: 'Mendoza' },
            { value: 'otra', label: 'Otra provincia / jurisdicción' },
        ],
    },
];
export const CONSENT_TEXT = 'Acepto que el Espacio de Innovación con IA de CESSI utilice los datos proporcionados para (a) generar y enviarme el perfil de madurez de mi organización y (b) elaborar resultados agregados y anónimos de la industria. Las respuestas individuales no se comparten con terceros. Datos personales (nombre y email) tratados conforme a la Ley 25.326; puede solicitarse acceso, rectificación o supresión escribiendo a [email de contacto de la mesa].';
export const THANKS_TEXT = '¡Gracias! Su autoevaluación quedó registrada. Recibirá por email el perfil de madurez de su organización con tres capacidades recomendadas para el próximo trimestre. Los resultados agregados se publican solo de forma anónima.';
/** Una sola salida no puntuable; se persiste como `na` (0 puntos). */
export const OPCIONES_RESPUESTA_ESPECIAL = [
    {
        letra: 'na',
        texto: 'No aplica / No sabe / No contesta',
        ayuda: 'La práctica no corresponde, no cuenta con información suficiente o prefiere no responder.',
    },
];
function q(id, texto, ayuda, a, b, c, d) {
    return {
        id,
        texto,
        ayuda,
        opciones: [
            { letra: 'a', texto: a.texto, ...(a.ayuda ? { ayuda: a.ayuda } : {}) },
            { letra: 'b', texto: b.texto, ...(b.ayuda ? { ayuda: b.ayuda } : {}) },
            { letra: 'c', texto: c.texto, ...(c.ayuda ? { ayuda: c.ayuda } : {}) },
            { letra: 'd', texto: d.texto, ...(d.ayuda ? { ayuda: d.ayuda } : {}) },
            ...OPCIONES_RESPUESTA_ESPECIAL,
        ],
    };
}
/**
 * Bloques 1–6: textos oficiales Autoevaluación v1.0 con ajustes Framework v1.4
 * (G.2 c y G.3 d según sitio v1.4). Opciones a–d sin etiquetas N + salida `na`.
 * No cambiar ids EV1..IN4 (contrato de scoring/CSV). El campo `ayuda` es solo UX.
 */
export const BLOQUES = [
    {
        code: 'EV',
        titulo: 'Estrategia y Valor',
        preguntas: [
            q('EV1', '¿Qué lugar ocupa la IA en la agenda de la dirección?', 'Mide si la IA es tema de la dirección, con objetivos y presupuesto propios, o si depende del interés de algunas personas. “Sponsor” = directivo que respalda la iniciativa y consigue recursos.', {
                texto: 'Se sigue con interés; no hay agenda formal ni presupuesto.',
                ayuda: 'Hay curiosidad, pero la IA no figura en la agenda ni tiene recursos asignados.',
            }, {
                texto: 'Hay un sponsor directivo que consigue recursos para iniciativas puntuales.',
                ayuda: 'Un directivo empuja y destraba recursos, todavía caso por caso.',
            }, {
                texto: 'Está en el plan anual, con objetivos, presupuesto propio y revisión periódica de la dirección.',
                ayuda: 'La IA es parte formal de la planificación y la dirección la sigue con regularidad.',
            }, {
                texto: 'La visión del negocio se formula desde las capacidades que la IA habilita; somos referencia para clientes y pares.',
                ayuda: 'La IA define hacia dónde va el negocio y la organización es referente en el mercado.',
            }),
            q('EV2', '¿Cómo se eligen las iniciativas de IA?', 'Mide cómo se decide qué iniciativas de IA hacer y cuáles descartar. RICE = método de priorización (alcance, impacto, confianza, esfuerzo). Business case = justificación del valor esperado.', {
                texto: 'Surgen espontáneamente de los equipos; nadie tiene la foto completa.',
                ayuda: 'No hay inventario de lo que se está probando ni criterio para elegir.',
            }, {
                texto: 'Se aprueban caso por caso, sin criterio comparativo.',
                ayuda: 'Cada iniciativa se decide aislada, sin compararla con las demás.',
            }, {
                texto: 'Hay un portfolio priorizado con criterios explícitos (impacto/esfuerzo, RICE); las iniciativas de valor llevan business case y las inversiones de capacidad llevan hipótesis, límite y fecha de decisión. Se descarta y se documenta por qué.',
                ayuda: 'Hay una lista priorizada con criterio explícito y registro de lo que se descarta.',
            }, {
                texto: 'Se gestiona como cartera de inversión por horizontes, con métricas de valor y capacidad de detener rápido lo que no rinde.',
                ayuda: 'Las iniciativas se gestionan como inversiones, con métricas y corte rápido de lo que no rinde.',
            }),
            q('EV3', '¿Cómo se mide el impacto de la IA?', 'Mide si hay números sobre lo que aporta la IA, más allá de cuánto se usa. “Línea de base” = medición previa que permite comparar el antes y el después.', {
                texto: 'No se mide; el relato es anecdótico.',
                ayuda: 'Solo hay impresiones u opiniones, sin indicadores.',
            }, {
                texto: 'Medimos adopción y uso (quién usa qué herramienta).',
                ayuda: 'Se sabe quién usa qué, pero no qué resultado produce.',
            }, {
                texto: 'Medimos productividad y calidad en las iniciativas clave, con línea de base previa.',
                ayuda: 'Se compara contra una medición previa en las iniciativas importantes.',
            }, {
                texto: 'Demostramos impacto en resultados de negocio ante terceros (clientes, directorio) y lo usamos en el pricing.',
                ayuda: 'El impacto se demuestra a clientes y directorio, y se refleja en los precios.',
            }),
            q('EV4', '¿Qué cambió en el negocio por la IA?', 'Mide si la IA cambió la oferta y la forma de cobrar, no solo la productividad interna. “Cobrar por el resultado” = facturar el valor entregado y no las horas o artefactos producidos.', {
                texto: 'Nada todavía; la IA es, como mucho, productividad interna.',
                ayuda: 'La oferta y la forma de cobrar siguen iguales.',
            }, {
                texto: 'Hay conciencia de qué parte de la oferta está expuesta, sin decisiones concretas.',
                ayuda: 'Se identificó qué parte de la oferta pierde valor con IA, sin acciones todavía.',
            }, {
                texto: 'Rediseñamos ofertas existentes (repriceadas o reempaquetadas) y tenemos al menos una oferta nueva habilitada por IA en el mercado.',
                ayuda: 'Ya hay ofertas rediseñadas y al menos una oferta nueva en el mercado.',
            }, {
                texto: 'Revisamos sistemáticamente qué parte del negocio pierde valor, lanzamos y retiramos ofertas con cadencia y cobramos por el resultado, no por el artefacto.',
                ayuda: 'La cartera de ofertas se revisa con método y se cobra por resultado.',
            }),
            q('EV5', '¿Cómo se gestionan los costos y la inversión en IA?', 'Mide si se sabe cuánto se gasta en IA, en qué y qué rinde. “Shadow spend” = gasto en herramientas pagado por fuera de los canales oficiales (tarjetas personales o de equipo).', {
                texto: 'No sabemos cuánto gastamos en IA: suscripciones dispersas en tarjetas y centros de costo distintos.',
                ayuda: 'El gasto está invisible o fragmentado; no hay vista consolidada.',
            }, {
                texto: 'El gasto está inventariado y visible, pero las compras se deciden caso por caso.',
                ayuda: 'Hay inventario, aún sin criterios de rentabilidad ni migración.',
            }, {
                texto: 'El costo se asigna por equipo y proyecto, se evalúa la rentabilidad antes de adoptar o escalar, hay criterios de migración entre plataformas y las inversiones de capacidad tienen presupuesto propio.',
                ayuda: 'Hay disciplina de costo y categoría propia para inversiones de capacidad.',
            }, {
                texto: 'Conocemos y optimizamos el costo por unidad de valor y modelamos su relación con el precio de nuestra oferta.',
                ayuda: 'El costo de IA se gestiona como variable de negocio y pricing.',
            }),
        ],
    },
    {
        code: 'PC',
        titulo: 'Personas y Cultura',
        preguntas: [
            q('PC1', '¿Quién impulsa y sostiene la adopción de IA?', 'Mide quién es dueño de la adopción y si tiene tiempo y mandato. “Champions” = referentes por área con horas asignadas; “squad” o “hub” = equipo dedicado a impulsar la adopción.', {
                texto: 'Entusiastas aislados, por su cuenta; si se van, el conocimiento se va con ellos.',
                ayuda: 'La adopción depende de personas sueltas; si se van, no queda nada.',
            }, {
                texto: 'Referentes identificados de manera informal, sin mandato ni tiempo asignado.',
                ayuda: 'Hay referentes conocidos, pero sin rol formal ni horas asignadas.',
            }, {
                texto: 'Un modelo activo con recursos: squad, red de champions o hub con tiempo protegido; el dueño de la adopción es explícito desde el onboarding.',
                ayuda: 'Hay un modelo con recursos y un dueño visible de la adopción desde el ingreso.',
            }, {
                texto: 'La adopción está en los objetivos e incentivos de toda la línea de mando; la estructura dedicada explora la frontera.',
                ayuda: 'Todos los líderes tienen objetivos de adopción; el equipo dedicado explora lo próximo.',
            }),
            q('PC2', '¿Cómo se forma la gente en IA?', 'Mide si la formación es por rol, sobre trabajo real, y si se verifica que se aplique (no solo la satisfacción con el curso). “Pairing” = trabajar de a dos para aprender en la práctica.', {
                texto: 'Cada uno aprende por su cuenta.',
                ayuda: 'No hay formación organizada.',
            }, {
                texto: 'Capacitaciones puntuales cuando surge la necesidad.',
                ayuda: 'Cursos aislados, sin continuidad ni seguimiento.',
            }, {
                texto: 'Programa continuo diferenciado por rol, sobre trabajo real, con evaluación de aplicación a 30 días y habilidades blandas incluidas.',
                ayuda: 'Rutas por rol, con práctica sobre trabajo real y control de aplicación al mes.',
            }, {
                texto: 'El aprendizaje está integrado al trabajo diario (pairing, revisión entre pares, biblioteca viva) y formamos a otros (clientes, ecosistema).',
                ayuda: 'Se aprende trabajando y la organización también forma a clientes y al ecosistema.',
            }),
            q('PC3', '¿Cómo cambiaron los roles y el pipeline de talento?', 'Mide si se rediseñaron los roles de todo el ciclo (no solo desarrollo) y cómo se formarán los futuros seniors. “Pipeline de talento” = el camino por el que los juniors llegan a ser seniors.', {
                texto: 'Sin cambios formales; cada uno negocia el cambio en soledad; la pregunta por los juniors no se abordó.',
                ayuda: 'Los roles no cambiaron formalmente y nadie abordó el futuro de los juniors.',
            }, {
                texto: 'Conversaciones iniciadas sobre reperfilamiento; ensayos aislados sin política.',
                ayuda: 'Se empezó a hablar de reperfilar roles, sin una política definida.',
            }, {
                texto: 'Roles de todo el ciclo ajustados formalmente (más diseño, verificación y criterio) y pipeline junior rediseñado con mentoría estructurada.',
                ayuda: 'Roles redefinidos formalmente y un programa junior con mentoría.',
            }, {
                texto: 'Estructura de equipos nativa de IA, carreras redefinidas y producción deliberada de seniors; la experiencia senior se captura de forma sistemática.',
                ayuda: 'Equipos y carreras pensados desde la IA, con formación deliberada de seniors.',
            }),
            q('PC4', '¿Cómo se gestiona el cambio y el ánimo del equipo?', 'Mide si se gestiona el impacto emocional de la IA (entusiasmo, miedo, sobrecarga) y no solo se comunica. “Victorias tempranas” = logros visibles que generan confianza en el cambio.', {
                texto: 'No se gestiona; conviven entusiasmo, escepticismo y miedo.',
                ayuda: 'Nadie se ocupa del clima ni de las preocupaciones del equipo.',
            }, {
                texto: 'Se comunica (anuncios, town halls), sin plan sostenido ni escucha.',
                ayuda: 'Hay anuncios, pero sin seguimiento ni espacios para escuchar.',
            }, {
                texto: 'Plan de gestión del cambio activo: coalición, victorias tempranas, espacio para la resistencia, acompañamiento y monitoreo de carga.',
                ayuda: 'Hay un plan de cambio con acompañamiento y seguimiento de la carga de trabajo.',
            }, {
                texto: 'El cambio continuo es parte de la identidad; el equipo lo protagoniza y los errores de exploración se procesan sin castigo.',
                ayuda: 'El equipo lidera el cambio y los errores al explorar no se castigan.',
            }),
        ],
    },
    {
        code: 'OD',
        titulo: 'Operación y Delivery',
        preguntas: [
            q('OD1', '¿Cómo se usa la IA en el flujo de producción?', 'Mide si hay una forma común de trabajar con IA al producir (software o servicios). El ciclo es: dar contexto, pedir, verificar, refinar e integrar. “Agentes” = sistemas de IA que ejecutan tareas de varios pasos.', {
                texto: 'Uso individual y dispar; cada uno con su herramienta y su estilo.',
                ayuda: 'Cada persona usa la IA a su manera.',
            }, {
                texto: 'El ciclo (contexto → pedir → verificar → refinar → integrar) está definido y se aplica en proyectos piloto.',
                ayuda: 'Hay un ciclo de trabajo definido, probado en algunos proyectos.',
            }, {
                texto: 'El ciclo es el estándar de la operación bajo una metodología explícita; el contexto y las decisiones se capturan, versionan y reutilizan.',
                ayuda: 'El ciclo es la norma y el contexto de cada proyecto queda guardado y se reutiliza.',
            }, {
                texto: 'El delivery está rediseñado de punta a punta, con agentes integrados a los procesos y personas en los puntos de mayor juicio.',
                ayuda: 'Los procesos se rediseñaron con agentes y personas en las decisiones clave.',
            }),
            q('OD2', '¿Cómo se verifica lo que la IA genera?', 'Mide cómo se controla la calidad de lo que produce la IA antes de llegar a producción o al cliente. “Proporcional al riesgo” = más control donde un error cuesta más.', {
                texto: 'Confiamos en el criterio de cada uno; no sabemos cuánto llegó a producción sin revisar.',
                ayuda: 'Se confía en cada persona y no hay registro de revisiones.',
            }, {
                texto: 'Revisiones ad hoc cuando el resultado se percibe crítico.',
                ayuda: 'Se revisa solo cuando algo parece importante.',
            }, {
                texto: 'Controles proporcionales al riesgo en todo el ciclo: verificación humana obligatoria y registrada, pruebas automatizadas ampliadas.',
                ayuda: 'Hay revisión humana obligatoria y registrada, y más pruebas automáticas.',
            }, {
                texto: 'Verificación sistemática en capas (automatizada donde escala, experta donde importa), con calidad medida y comunicada a clientes.',
                ayuda: 'La verificación combina automatización y expertos; la calidad se mide y se informa.',
            }),
            q('OD3', '¿Qué pasa entre el prototipo y producción?', 'Mide si lo que se prototipa rápido con IA llega a producción de forma repetible. MVP = primera versión mínima usable. “Industrializar” = dejarlo listo para operar (seguridad, escala, soporte).', {
                texto: 'Los MVPs generados con IA quedan en demo.',
                ayuda: 'Los prototipos no pasan de la demo.',
            }, {
                texto: 'Algunos llegan a producción, con mucho retrabajo y dependiendo de personas específicas.',
                ayuda: 'Algunos llegan, con mucho esfuerzo y dependiendo de personas clave.',
            }, {
                texto: 'Tenemos un camino repetible: checklist de industrialización, esfuerzo estimable y roles del tramo (DevOps, arquitectura) equipados.',
                ayuda: 'Hay un camino estándar y se estima el costo de llevar a producción.',
            }, {
                texto: 'El ciclo idea → producción es una ventaja competitiva que cotizamos y vendemos.',
                ayuda: 'Pasar rápido de idea a producción es un servicio que se vende.',
            }),
            q('OD4', '¿Cómo está la plataforma de herramientas de IA?', 'Mide si las herramientas de IA están integradas y administradas (accesos, licencias, conexión a repositorios y datos) o dispersas. “Homologar” = aprobar oficialmente una herramienta para su uso.', {
                texto: 'Suscripciones sueltas, sin criterio común ni visibilidad central.',
                ayuda: 'Cada uno contrata lo suyo y nadie tiene la vista completa.',
            }, {
                texto: 'Stack piloto acotado con accesos administrados; licencias en proceso de homologación.',
                ayuda: 'Hay un conjunto acotado de herramientas con accesos controlados.',
            }, {
                texto: 'Plataforma integrada al stack: identidad y accesos, licencias homologadas, conexión a repositorio, CI/CD y datos.',
                ayuda: 'Las herramientas están conectadas a la identidad, el código y los datos de la organización.',
            }, {
                texto: 'Arquitectura preparada para IA como capa: modelos intercambiables, agentes con permisos gobernados, observabilidad de uso y costo.',
                ayuda: 'Los modelos se pueden cambiar y los agentes operan con permisos y costos controlados.',
            }),
        ],
    },
    {
        code: 'DC',
        titulo: 'Datos y Conocimiento',
        preguntas: [
            q('DC1', '¿En qué estado están los datos para las iniciativas de IA?', 'Mide si los datos que necesitan las iniciativas tienen dueño, calidad conocida y acceso seguro. “Blueprint” = mapa previo de qué datos usa una iniciativa y dónde están.', {
                texto: 'Dispersos, calidad desconocida, sin dueños.',
                ayuda: 'No se sabe bien qué datos hay, en qué estado ni de quién son.',
            }, {
                texto: 'Mapeados por iniciativa (blueprint), con gobierno solo local.',
                ayuda: 'Cada iniciativa mapea sus datos, pero no hay gobierno común.',
            }, {
                texto: 'Gobernados: dueños, calidad gestionada en fuentes críticas, acceso ágil y ambientes seguros para experimentar.',
                ayuda: 'Los datos críticos tienen dueño, calidad gestionada y un ambiente seguro para probar.',
            }, {
                texto: 'Son un activo con valor medible que habilita productos y decisiones.',
                ayuda: 'Los datos son un activo que genera productos y decisiones con valor medible.',
            }),
            q('DC2', '¿Dónde vive el conocimiento de dominio (el del negocio propio y el de los clientes)?', 'Mide si el conocimiento del negocio y de los clientes está escrito de forma que lo usen personas y modelos de IA, o si depende de quién lo sabe. “Dominio” = el saber específico del negocio o del cliente.', {
                texto: 'En las cabezas de la gente.',
                ayuda: 'El conocimiento depende de quién lo tiene en la cabeza.',
            }, {
                texto: 'En documentación parcial y dispersa, escrita para humanos con tiempo.',
                ayuda: 'Hay documentos sueltos, difíciles de usar y de mantener.',
            }, {
                texto: 'Capturado con método para personas y modelos: decisiones con su porqué, heurísticas y casos límite de los expertos, actualizado como parte del trabajo.',
                ayuda: 'Se documenta con método, incluido el porqué de las decisiones, y se mantiene al día.',
            }, {
                texto: 'Es el activo estratégico central: cada proyecto lo enriquece y nuestra IA "sabe" del dominio.',
                ayuda: 'Cada proyecto enriquece el conocimiento y la IA lo aprovecha.',
            }),
            q('DC3', '¿Cuánto se reutiliza entre proyectos (prompts, playbooks, plantillas de contexto)?', 'Mide si los proyectos aprovechan prompts, playbooks y plantillas ya probados. “Playbook” = guía paso a paso para un tipo de tarea; “curaduría” = alguien revisa y mantiene la biblioteca.', {
                texto: 'Cada proyecto arranca de cero.',
                ayuda: 'No se aprovecha lo hecho antes.',
            }, {
                texto: 'Se comparte informalmente, sin curaduría ni versionado.',
                ayuda: 'Se pasan cosas entre personas, sin orden ni versiones.',
            }, {
                texto: 'Biblioteca común curada, con dueño, en uso real.',
                ayuda: 'Hay una biblioteca mantenida por un responsable y se usa de verdad.',
            }, {
                texto: 'La reutilización es sistemática y medida; acelera cada proyecto nuevo.',
                ayuda: 'Reutilizar es la norma y se mide cuánto acelera.',
            }),
            q('DC4', '¿Cómo se gestiona el conocimiento como disciplina?', 'Mide si hay método y responsables para capturar, especificar, guardar y medir el conocimiento que usan personas y agentes, y si está claro qué conocimiento pertenece al cliente.', {
                texto: 'No hay práctica: se documenta si alguien tiene tiempo, sin método ni responsable.',
                ayuda: 'Nadie es responsable y no hay método.',
            }, {
                texto: 'Primeras prácticas de extracción en iniciativas puntuales (entrevistas a expertos, captura al cierre).',
                ayuda: 'Se captura conocimiento en algunos proyectos, por ejemplo al cerrarlos.',
            }, {
                texto: 'Disciplina operando: método de extracción, especificación para personas y modelos, base de conocimiento gobernada, roles asignados, calidad medida y regla de propiedad del conocimiento del cliente.',
                ayuda: 'Hay método, roles, base gobernada, calidad medida y reglas sobre el conocimiento del cliente.',
            }, {
                texto: 'El sistema de conocimiento es infraestructura: alimenta agentes en producción y su calidad se gestiona como la del software.',
                ayuda: 'El conocimiento alimenta agentes en producción y se gestiona como el software.',
            }),
        ],
    },
    {
        code: 'GS',
        titulo: 'Gobernanza, Seguridad y Cumplimiento',
        preguntas: [
            q('GS1', '¿Qué reglas de uso de IA existen y quién las conoce?', 'Mide si hay reglas de uso de IA, si la gente las conoce (verificado, no solo declarado) y si se actualizan. “Uso silencioso” = uso de IA que la organización no ve ni regula.', {
                texto: 'No hay reglas explícitas; convive el uso silencioso.',
                ayuda: 'No hay reglas y cada uno usa la IA sin que nadie lo vea.',
            }, {
                texto: 'Lineamientos mínimos comunicados; cumplimiento voluntario y control reactivo.',
                ayuda: 'Hay pautas básicas, pero se cumplen si cada uno quiere.',
            }, {
                texto: 'Política viva, conocida por todos con verificación preventiva, con excepciones ágiles y actualización periódica.',
                ayuda: 'La política se conoce, se verifica antes de que haya problemas y se actualiza.',
            }, {
                texto: 'Gobernanza demostrable ante clientes y auditores; nuestra política es referencia para otros.',
                ayuda: 'La gobernanza se puede mostrar a clientes y auditores, y otros la toman de modelo.',
            }),
            q('GS2', '¿Cómo se protegen los datos propios y de clientes frente a los modelos?', 'Mide qué datos se exponen a qué modelos y con qué acuerdos. “Datos sintéticos” = datos ficticios que imitan a los reales; “anonimizar” = quitar lo que identifica a personas o clientes. Las referencias normativas orientan y no constituyen asesoramiento legal.', {
                texto: 'No evaluamos qué datos se exponen; las demos usan datos reales.',
                ayuda: 'No se controla qué datos llegan a los modelos.',
            }, {
                texto: 'Restricciones básicas (qué no subir) y primeras revisiones de términos de proveedores.',
                ayuda: 'Hay reglas mínimas y se empezaron a leer los términos de los proveedores.',
            }, {
                texto: 'Controles técnicos y contractuales: clasificación, acuerdos con proveedores, cláusulas de IA con clientes, cumplimiento revisado con asesoría, datos seguros por defecto en demos y pilotos (sintéticos, anonimizados u otros controles según riesgo).',
                ayuda: 'Datos clasificados, contratos con proveedores y clientes, y demos y pilotos sin datos reales expuestos.',
            }, {
                texto: 'Privacidad by design en todo el ciclo, auditable; nos abre sectores regulados y exportación.',
                ayuda: 'La privacidad está en todo el proceso, se puede auditar y abre mercados exigentes.',
            }),
            q('GS3', '¿Cómo se gobiernan calidad, seguridad y trazabilidad en el delivery?', 'Mide si se puede mostrar qué se generó con IA, con qué modelo y quién lo verificó. RNF = requisitos no funcionales (seguridad, rendimiento, mantenibilidad). “Corresponsabilidad” = acuerdo previo con el cliente sobre quién responde por qué.', {
                texto: 'Los requisitos no funcionales se ven al final, si se ven.',
                ayuda: 'Seguridad y calidad aparecen tarde o nunca.',
            }, {
                texto: 'Checklist informal en algunos proyectos; revisión humana sin registro.',
                ayuda: 'Hay checklists en algunos proyectos, sin registro de quién revisó.',
            }, {
                texto: 'RNF integrados al flujo con trazabilidad (qué se generó, con qué modelo, quién verificó), alcance definido por modalidad de servicio y acuerdo de corresponsabilidad con el cliente por iniciativa.',
                ayuda: 'Hay trazabilidad en el flujo y acuerdos con el cliente antes de empezar.',
            }, {
                texto: 'Gobernanza del delivery continua con evidencia automática; es parte de nuestra propuesta de valor.',
                ayuda: 'La evidencia se genera sola y es parte de lo que se vende.',
            }),
            q('GS4', '¿Cómo se gestionan los riesgos de IA?', 'Mide si los riesgos de IA están identificados, con dueño y plan. “Apetito de riesgo” = cuánto riesgo acepta la dirección y qué decide no delegar en IA. ISO/IEC 42001 = norma de gestión de IA (referencia, no requisito).', {
                texto: 'No tenemos mapa de riesgos de IA.',
                ayuda: 'No hay una lista de riesgos de IA.',
            }, {
                texto: 'Riesgos identificados, sin dueños ni plan.',
                ayuda: 'Los riesgos se conocen, pero nadie es responsable de mitigarlos.',
            }, {
                texto: 'Riesgos gestionados: matriz viva con dueños, mitigaciones y plan de respuesta a incidentes.',
                ayuda: 'Hay una matriz de riesgos con dueños y un plan ante incidentes.',
            }, {
                texto: 'Apetito de riesgo definido por la dirección, revisión periódica e integración al negocio (alineable con ISO/IEC 42001).',
                ayuda: 'La dirección define cuánto riesgo acepta y lo revisa periódicamente.',
            }),
        ],
    },
    {
        code: 'IN',
        titulo: 'Innovación con IA',
        preguntas: [
            q('IN1', '¿Cómo experimenta la organización con IA?', 'Mide si la experimentación con IA tiene método: cadencia, criterios de éxito y un portfolio de apuestas. “Piloto” = prueba acotada en condiciones reales.', {
                texto: 'No experimentamos de forma organizada.',
                ayuda: 'No hay experimentación organizada.',
            }, {
                texto: 'Experimentos aislados cuando surge la oportunidad.',
                ayuda: 'Se experimenta de vez en cuando, sin continuidad.',
            }, {
                texto: 'Pipeline de experimentos y pilotos con cadencia y criterios de éxito definidos.',
                ayuda: 'Los experimentos tienen ritmo y criterios de éxito definidos.',
            }, {
                texto: 'Motor de innovación continuo: un portfolio de apuestas gestionado.',
                ayuda: 'Hay una cartera de apuestas gestionada de forma continua.',
            }),
            q('IN2', '¿Qué recursos hay para innovar con IA?', 'Mide si hay tiempo y presupuesto dedicados a explorar con IA, separados de la operación diaria. “Lab” = equipo o espacio dedicado a explorar.', {
                texto: 'Sin tiempo ni presupuesto asignados.',
                ayuda: 'No hay tiempo ni presupuesto para explorar.',
            }, {
                texto: 'Tiempo "robado" a la operación.',
                ayuda: 'Se explora a costa del trabajo diario.',
            }, {
                texto: 'Presupuesto y tiempo protegidos para explorar.',
                ayuda: 'Hay presupuesto y tiempo reservados para explorar.',
            }, {
                texto: 'Estructura dedicada (equipo o lab) con objetivos propios.',
                ayuda: 'Hay un equipo dedicado con objetivos propios.',
            }),
            q('IN3', '¿Qué pasa con los experimentos que funcionan?', 'Mide si los experimentos exitosos escalan a la operación con un proceso definido, y si se detiene lo que no funciona. “Tasa de conversión” = proporción de experimentos que llegan a producción.', {
                texto: 'No suelen pasar de la prueba.',
                ayuda: 'Los experimentos quedan en prueba.',
            }, {
                texto: 'Algunos se implementan, sin proceso claro.',
                ayuda: 'Algunos se adoptan, sin un camino claro.',
            }, {
                texto: 'Proceso definido para escalar lo que funciona (y detener lo que no).',
                ayuda: 'Hay un proceso para escalar lo que funciona y cortar lo que no.',
            }, {
                texto: 'Conocemos y mejoramos la tasa de conversión experimento → producción.',
                ayuda: 'Se mide y mejora cuántos experimentos llegan a producción.',
            }),
            q('IN4', '¿La IA cambió lo que ofrecen al mercado?', 'Mide si la IA llegó a la oferta: servicios mejorados, productos nuevos o una oferta que se redefine con la IA como capacidad central del negocio.', {
                texto: 'No cambió nuestra oferta.',
                ayuda: 'La oferta sigue igual que antes de la IA.',
            }, {
                texto: 'Mejoramos servicios existentes con IA.',
                ayuda: 'Los servicios actuales incorporan IA.',
            }, {
                texto: 'Lanzamos al menos un servicio o producto nuevo habilitado por IA.',
                ayuda: 'Hay al menos un producto o servicio nuevo gracias a la IA.',
            }, {
                texto: 'La oferta se reformula continuamente: la IA es una capacidad central del negocio.',
                ayuda: 'La IA está en el centro de la oferta, que se renueva constantemente.',
            }),
        ],
    },
];
/** Niveles oficiales Framework v1.4 (formato «Nn · Nombre — descripción»; la UI quita «Nn · »). */
export const DESCRIPTORES_NIVEL = {
    1: 'N1 · Exploración — uso individual y espontáneo, sin gobierno ni métricas',
    2: 'N2 · Piloto — iniciativas acotadas con responsables y primeras métricas',
    3: 'N3 · Adopción sistemática — prácticas integradas al flujo estándar, con gobierno operativo y medición en uso',
    4: 'N4 · Transformación — la capacidad redefine la oferta y el modelo de negocio, con gobernanza auditable',
};
export const RECOMENDACIONES = {
    EV: [
        'Explicitar 3 casos de uso prioritarios con sponsor ejecutivo y KPI de negocio.',
        'Armar un portfolio trimestral de IA con criterios de valor, riesgo y effort.',
        'Reservar un presupuesto recurrente (no solo piloto) ligado a outcomes.',
    ],
    PC: [
        'Lanzar un programa corto de alfabetización IA para líderes y delivery.',
        'Definir roles mínimos (product owner IA / champion por unidad).',
        'Crear una comunidad de práctica con demos quincenales y normas de uso.',
    ],
    OD: [
        'Estandarizar un path a producción (environments, secrets, observabilidad).',
        'Elegir una plataforma base (LLM gateway / vector / evals) y descontinuar duplicados.',
        'Incluir checks de calidad de prompts/modelos en el pipeline de CI.',
    ],
    DC: [
        'Inventariar fuentes de conocimiento críticas y dueños de datos.',
        'Publicar guías de qué datos/PII pueden entrar a modelos externos.',
        'Montar un catálogo mínimo reutilizable (datasets, embeddings, prompts).',
    ],
    GS: [
        'Publicar política de uso aceptable de IA y proveedores.',
        'Exigir evaluación de riesgo antes de producción (privacidad, IP, bias).',
        'Activar logging y controles DLP en los canales de LLM más usados.',
    ],
    IN: [
        'Instalar un funnel de ideas → spike → pilot → scale con criterios de kill.',
        'Correr 1 challenge de innovación con clientes reales por trimestre.',
        'Documentar aprendizajes de pilots fallidos para no repetir costo.',
    ],
};
export function recomendacionesPara(dimension, max = 3) {
    return (RECOMENDACIONES[dimension] ?? []).slice(0, max);
}
export { FICHAS_FRAMEWORK, FRAMEWORK_VERSION, ORDEN_FICHAS, codigoASlug, fichaPorCodigo, pathCapacidad, textosFichas, urlCapacidad, urlRecomendacion, nivelesParaMapa, fechaRecomendacion, } from './fichas.js';
/** Buckets de corte para agregado (apertura). */
export function bucketModeloNegocio(p0_1) {
    if (p0_1 === 'solo_productos' || p0_1 === 'mayormente_productos')
        return 'producto';
    if (p0_1 === 'solo_servicios' || p0_1 === 'mayormente_servicios')
        return 'servicios';
    return 'mixto';
}
export function bucketTamano(p0_3) {
    if (p0_3 === '1-10' || p0_3 === '11-50')
        return 'hasta_50';
    if (p0_3 === '51-200')
        return '51_200';
    return 'mas_200';
}
export function bucketGeo(p0_5) {
    if (p0_5 === 'solo_ar')
        return 'solo_ar';
    if (p0_5 === 'ar_1_3' || p0_5 === 'ar_4_10')
        return 'regional';
    return 'global';
}
export function bucketExportacion(p0_6) {
    if (p0_6 === '0')
        return 'no_exporta';
    if (p0_6 === 'gt50')
        return 'exportadora';
    return 'lt50';
}
/** Pregunta guía de cada dimensión (sitio Framework v1.4), mostrada al entrar al bloque (§4.2). */
export const TRANSICION_DIMENSION = {
    EV: '¿La IA es agenda de la dirección — y podemos demostrar con números lo que aporta?',
    PC: '¿Quién sostiene la adopción cuando pasa el entusiasmo inicial?',
    OD: '¿Podemos controlar y verificar al ritmo al que ahora producimos?',
    DC: '¿Nuestros datos y nuestro conocimiento del negocio están en condiciones de alimentar lo que queremos construir?',
    GS: '¿Podemos explicar y defender cómo usamos IA ante un cliente, un auditor o un regulador?',
    IN: '¿La organización experimenta con método y convierte los experimentos en valor?',
};
export const PERSONAL_EMAIL_DOMAINS = [
    'gmail.com',
    'googlemail.com',
    'hotmail.com',
    'outlook.com',
    'live.com',
    'yahoo.com',
    'yahoo.com.ar',
    'icloud.com',
    'me.com',
    'proton.me',
    'protonmail.com',
];
export function esEmailPersonal(email) {
    const domain = email.split('@')[1]?.toLowerCase() ?? '';
    return PERSONAL_EMAIL_DOMAINS.includes(domain);
}
//# sourceMappingURL=index.js.map